const BRAND_REPLACEMENTS = [
  [/Minerals Route's/gi, "Nova Concepts'"],
  [/Mineral Routes's/gi, "Nova Concepts'"],
  [/Mineral Route's/gi, "Nova Concepts'"],
  [/MINERALS ROUTE'S/gi, "NOVA CONCEPTS'"],
  [/MINERAL ROUTES'S/gi, "NOVA CONCEPTS'"],
  [/MINERAL ROUTE'S/gi, "NOVA CONCEPTS'"],
  [/Minerals Route/gi, 'Nova Concepts'],
  [/Mineral Routes/gi, 'Nova Concepts'],
  [/Mineral Route/gi, 'Nova Concepts'],
  [/MINERALS ROUTE/gi, 'NOVA CONCEPTS'],
  [/MINERAL ROUTES/gi, 'NOVA CONCEPTS'],
  [/MINERAL ROUTE/gi, 'NOVA CONCEPTS']
];

const SKIP_REBRAND_KEYS = new Set([
  'id',
  'main_image',
  'gallery_images',
  'image',
  'file',
  'url',
  'href',
  'created_at',
  'updated_at',
  'customer_visibility',
  'visible_customers',
  'category_id',
  'subcategory_id',
  'sub_subcategory_id',
  'product_id',
  'customer_id',
  'stone_type_id'
]);

export function rebrandText(value) {
  if (!value || typeof value !== 'string') return value;

  return BRAND_REPLACEMENTS.reduce(
    (text, [pattern, replacement]) => text.replace(pattern, replacement),
    value
  );
}

function rebrandUnknownValue(value) {
  if (typeof value === 'string') return rebrandText(value);
  if (Array.isArray(value)) return value.map(rebrandUnknownValue);
  if (value && typeof value === 'object') return rebrandRecord(value);
  return value;
}

export function rebrandRecord(record) {
  if (!record || typeof record !== 'object' || Array.isArray(record)) {
    return record;
  }

  const result = { ...record };

  Object.entries(record).forEach(([key, value]) => {
    if (SKIP_REBRAND_KEYS.has(key)) return;

    if (typeof value === 'string') {
      result[key] = rebrandText(value);
      return;
    }

    if (Array.isArray(value)) {
      result[key] = value.map((item) => rebrandUnknownValue(item));
      return;
    }

    if (value && typeof value === 'object') {
      result[key] = rebrandRecord(value);
    }
  });

  return result;
}

export function rebrandRecords(records) {
  if (!Array.isArray(records)) return [];
  return records.map(rebrandRecord);
}

export function rebrandProduct(product) {
  return rebrandRecord(product);
}

export function rebrandProducts(products) {
  return rebrandRecords(products);
}

export function rebrandStoredProducts(items) {
  return rebrandProducts(items);
}

export function rebrandCategoryMap(map) {
  if (!map || typeof map !== 'object') return {};
  return Object.fromEntries(
    Object.entries(map).map(([key, value]) => [key, rebrandRecords(value)])
  );
}

export function migrateStoredBranding() {
  ['mineralsCart', 'wishlist', 'mineralsComparison'].forEach((key) => {
    const raw = localStorage.getItem(key);
    if (!raw) return;

    try {
      localStorage.setItem(key, JSON.stringify(rebrandStoredProducts(JSON.parse(raw))));
    } catch {
      // Ignore invalid stored JSON.
    }
  });

  const navCacheKey = 'categoryNavData';
  const rawNav = localStorage.getItem(navCacheKey);
  if (!rawNav) return;

  try {
    const parsed = JSON.parse(rawNav);
    localStorage.setItem(
      navCacheKey,
      JSON.stringify({
        categoryIdByKey: parsed.categoryIdByKey || {},
        subcategoriesByCategoryId: rebrandCategoryMap(parsed.subcategoriesByCategoryId),
        subSubByCategoryId: rebrandCategoryMap(parsed.subSubByCategoryId)
      })
    );
  } catch {
    // Ignore invalid cached navigation data.
  }
}

export const rebrandProductDescriptions = rebrandProduct;
